"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpFiltering = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var IconToggle_1 = require("Common/IconToggle/IconToggle");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var IpFiltering = (function (_super) {
    __extends(IpFiltering, _super);
    function IpFiltering() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IpFiltering.prototype.render = function () {
        var _a = this.props, ipFilterStore = _a.ipFilterStore, disableSetting = _a.disableSetting, advancedSecurityUpsellMessage = _a.advancedSecurityUpsellMessage;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IconToggle_1.IconToggle, { icon: react_1.default.createElement(icons_1.Filter, null), label: "Enable IP Filtering", value: ipFilterStore.enabled, onChange: this.toggleEnabled, disabled: disableSetting, disabledMessage: advancedSecurityUpsellMessage }),
            ipFilterStore.enabled && (react_1.default.createElement("div", { className: "space-stack-s" },
                this.activeOfficeAddresses.length === 0 &&
                    this.renderNoFilters(),
                this.activeOfficeAddresses.length > 1 &&
                    this.renderFilterAll(),
                this.activeOfficeAddresses.map(function (_a) {
                    var _id = _a._id, name = _a.name;
                    return (react_1.default.createElement(kaleidoscope_1.Checkbox, { key: _id, id: _id, label: name, checked: ipFilterStore.isAddressSelected(_id), onChange: function () { return ipFilterStore.toggleAddress(_id); } }));
                })))));
    };
    IpFiltering.prototype.renderFilterAll = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.Checkbox, { id: "filter-all", label: "Filter all IPs", checked: this.areAllAddressesSelected, onChange: this.toggleAllAddresses }),
            react_1.default.createElement("hr", { className: "share-popover__separator" })));
    };
    IpFiltering.prototype.renderNoFilters = function () {
        return (react_1.default.createElement(kaleidoscope_1.Alert, { heading: "No filters to display", alertType: kaleidoscope_1.AlertType.Info },
            react_1.default.createElement("div", null,
                "Add filters in ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/settings/account" }, "settings"))));
    };
    IpFiltering.prototype.toggleEnabled = function () {
        var ipFilterStore = this.props.ipFilterStore;
        ipFilterStore.setEnabled(!ipFilterStore.enabled);
    };
    Object.defineProperty(IpFiltering.prototype, "activeOfficeAddresses", {
        get: function () {
            return this.props.officeIpAddresses.filter(function (_a) {
                var active = _a.active;
                return active;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IpFiltering.prototype, "areAllAddressesSelected", {
        get: function () {
            var e_1, _a;
            try {
                for (var _b = __values(this.activeOfficeAddresses), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var activeAddress = _c.value;
                    if (!this.props.ipFilterStore.isAddressSelected(activeAddress._id)) {
                        return false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    IpFiltering.prototype.toggleAllAddresses = function () {
        if (this.areAllAddressesSelected) {
            this.props.ipFilterStore.unselectAll();
        }
        else {
            this.props.ipFilterStore.selectAddresses(this.activeOfficeAddresses.map(function (value) { return value._id; }));
        }
    };
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], IpFiltering.prototype, "toggleEnabled", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], IpFiltering.prototype, "activeOfficeAddresses", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], IpFiltering.prototype, "areAllAddressesSelected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], IpFiltering.prototype, "toggleAllAddresses", null);
    IpFiltering = __decorate([
        mobx_react_1.observer
    ], IpFiltering);
    return IpFiltering;
}(react_1.default.Component));
exports.IpFiltering = IpFiltering;
